import { usePolygonStore } from '../../../../../state-library/src'
import { EHeatMapCategory } from '../../../../../types-library/src'
import { useState } from 'react'

interface Props {
  category: {
    id: EHeatMapCategory
    name: string
    icon: any
  }
  setIsOpened: (value: boolean) => void
}

const CategoryOption = ({ category, setIsOpened }: Props): JSX.Element => {
  const { setHeatMapCategory } = usePolygonStore()

  const [isHovered, setIsHovered] = useState(false)

  return (
    <button
      onClick={() => {
        setHeatMapCategory(category.id)
        setIsOpened(false)
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      type="button"
      className="p-1.5 bg-white rounded-full flex items-center gap-2 hover:pr-3 duration-200"
    >
      <div className="w-6 h-6 rounded-full ">
        <img
          src={category.icon}
          alt={category.name}
          width={48}
          height={48}
          className="w-full h-full"
        />
      </div>

      {isHovered ? (
        <div className="pr-1 animation-appear-03">
          <span className="text-body-bold-s text-primary">
            {category?.name}
          </span>
        </div>
      ) : null}
    </button>
  )
}

export default CategoryOption
